/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The call validity:
 *   * CALL DATE TOO OLD
 *   * VALID CALL
 */
export enum CallNotificationValidity {
  CALL_DATE_TOO_OLD = 'CALL_DATE_TOO_OLD',
  VALID_CALL = 'VALID_CALL'
}
